export const RESCISAO_ETAPAS = [
  { id: 1, titulo: 'Tipo de Rescisão', desc: 'Defina o motivo do desligamento' },
  { id: 2, titulo: 'Aviso Prévio', desc: 'Configure o aviso prévio' },
  { id: 3, titulo: 'Pendências', desc: 'Verifique itens em aberto' },
  { id: 4, titulo: 'Férias', desc: 'Saldo de férias do colaborador' },
  { id: 5, titulo: 'Benefícios', desc: 'Encerramento de benefícios' },
  { id: 6, titulo: 'Conferência', desc: 'Revisão completa do cálculo' },
  { id: 7, titulo: 'Documentos', desc: 'Geração de TRCT e documentos' },
] as const

export const RESCISAO_TIPOS = [
  {
    id: 'sem_justa_causa',
    label: 'Sem Justa Causa',
    desc: 'Empresa decide encerrar o contrato. Multa FGTS 40%, aviso prévio, seguro-desemprego.',
    lei: 'Art. 477 CLT',
  },
  {
    id: 'pedido_demissao',
    label: 'Pedido de Demissão',
    desc: 'Colaborador decide sair. Sem multa FGTS; pode perder seguro-desemprego.',
    lei: 'Art. 487 CLT',
  },
  {
    id: 'justa_causa',
    label: 'Justa Causa',
    desc: 'Demissão por falta grave (art. 482). Perde FGTS, aviso e direitos. Requer documentação.',
    lei: 'Art. 482 CLT',
  },
  {
    id: 'acordo_mutuo',
    label: 'Acordo Mútuo',
    desc: 'Art. 484-A: multa FGTS 20%, metade do aviso, sem seguro-desemprego.',
    lei: 'Art. 484-A CLT',
  },
  {
    id: 'termino_contrato',
    label: 'Término de Contrato',
    desc: 'Fim de contrato por prazo determinado. Aviso de 30 dias ou indenização.',
    lei: 'Art. 481 CLT',
  },
] as const

export const RESCISAO_PENDENCIAS = [
  { id: 'epi', label: 'EPIs devolvidos' },
  { id: 'cracha', label: 'Crachá/Cartão de Acesso devolvido' },
  { id: 'notebook', label: 'Notebook/Equipamentos devolvidos' },
  { id: 'exames', label: 'Exame demissional agendado' },
  { id: 'sistemas', label: 'Acessos aos sistemas revogados' },
  { id: 'beneficios', label: 'Cancelamento de benefícios iniciado' },
  { id: 'email', label: 'E-mail corporativo desativado' },
] as const

export const RESCISAO_DOCS = [
  { id: 'trct', nome: 'TRCT — Termo de Rescisão', desc: 'Documento oficial do desligamento' },
  { id: 'demonstrativo', nome: 'Demonstrativo de Rescisão', desc: 'Memória de cálculo detalhada' },
  { id: 'checklist', nome: 'Checklist de Desligamento', desc: 'Lista de pendências e obrigações' },
  { id: 'aviso', nome: 'Aviso Prévio', desc: 'Carta formal de aviso prévio' },
  { id: 'fgts', nome: 'Guia FGTS', desc: 'Informações para saque do FGTS' },
  { id: 'esocial', nome: 'Declaração eSocial (S-2299)', desc: 'Evento de desligamento para o eSocial' },
] as const

export function temAvisoPrevio(tipo: string) {
  return ['sem_justa_causa', 'termino_contrato', 'acordo_mutuo', 'pedido_demissao'].includes(tipo)
}

export function diasAvisoPrevio(dataAdmissao?: string | null, dataDemissao?: string | null) {
  if (!dataAdmissao) return 30
  const adm = new Date(`${dataAdmissao}T12:00:00`)
  const dem = dataDemissao ? new Date(`${dataDemissao}T12:00:00`) : new Date()
  if (Number.isNaN(adm.getTime()) || Number.isNaN(dem.getTime())) return 30
  const meses = Math.max(
    0,
    (dem.getFullYear() - adm.getFullYear()) * 12 + (dem.getMonth() - adm.getMonth()),
  )
  const anos = Math.floor(meses / 12)
  return Math.min(30 + anos * 3, 90)
}
